<template>
  <b-modal v-model="showLogModal"
           size="xl"
           hide-footer
           v-if="showLogModal"
           centered
           style="height: 85vh;"
           @hide="$emit('hide')">
    <template #modal-title>
      {{$lang.PCI.Mounting.SelectItems}} ({{contract.contract}})
    </template>
    <div class="d-flex flex-column align-items-stretch" style="height: calc(100vh - 150px);">
      <div class="d-flex flex-shrwrink-1 px-3">
        <ag-grid-vue class="ag-theme-alpine"
                     :getLocaleText="localeTextFunc"
                     :gridOptions="gridOptions"
                     :columnTypes="columnTypes"
                     :defaultColDef="defaultColumnDef"
                     :columnDefs="columnDefs"
                     :rowData="objList"
                     rowSelection="single"
                     @rowSelected="onSelectLine"
                     :suppressContextMenu="true"
                     :rowHeight="25"
                     domLayout='autoHeight'
                     style="width: 100%">
                     <!-- :getRowId="params => params.data.contractID" -->
        </ag-grid-vue>
      </div>
      <div class="d-flex flex-grow-1 h-100 pt-3" style="overflow-y: auto;">
        <div class="d-flex flex-column w-100 col-6">
          <div class="separator" v-if="currentLinkedContract.contractID !== beforeLinkedContract.contractID">{{ 'Contratos Vinculados (Anterior)' }}</div>
          <div class="d-flex flex-shrink-1 align-items-center w-100" v-if="currentLinkedContract.contractID !== beforeLinkedContract.contractID" style="height: 2.5rem;">
            <div class="d-flex flex-shrink-1">
              <v-select v-if="beforeLinkedContract.contractID" :options="listContract" v-model="beforeLinkedContract" label="contract" :getOptionKey="param => param.contractID" disabled class="w-100" :clearable="false"></v-select>
            </div>
          </div>
          <div class="separator" v-if="currentItemsDiff.length || logItemsDiff.length">{{ $lang.PCI.Mounting.Log.BeforeModifiedItems }}</div>
          <div class="d-flex flex-shrink-1 align-items-center w-100" v-for="(item, idx) in logItemsDiff" :key="'itemDiff' + idx" style="height: 2.5rem;">
            <div class="d-flex  flex-grow-1">
              <b-checkbox disabled v-model="item.Checked"> {{ `(${item.Codigo}) ${item.Descricao}` }}</b-checkbox>
            </div>
            <div class="d-flex flex-shrink-1">
              <b-checkbox class="d-flex align-items-center" v-if="item.PossuiCor" switch v-model="item.Colorido" disabled>
                <i class="fas fa-palette text-primary"></i>
              </b-checkbox>
              <div class="d-flex align-items-center" v-if="item.Automatizacoes.length" >
                <strong v-if="item.AutomatizacoesMont.length" class="pl-1">Autom.</strong>
                <v-select v-if="item.AutomatizacoesMont.length" :options="item.Automatizacoes" v-model="item.AutomatizacoesMont" label="nome" disabled :clearable="false"></v-select>
              </div>
              <div class="d-flex align-items-center" v-if="item.Validacoes.length" >
                <strong v-if="item.ValidacoesMont.length" class="pl-1">Valid.</strong>
                <v-select v-if="item.ValidacoesMont.length" :options="item.Validacoes" v-model="item.ValidacoesMont" label="nome" multiple disabled :clearable="false"></v-select>
              </div>
            </div>
          </div>
          <div class="separator" v-if="currentLpuAdded.length">{{ 'LPUs Adicionadas' }}</div>
          <div class="d-flex flex-shrink-1 align-items-center w-100" v-for="(lpu, idx) in currentLpuAdded" :key="'lpuAdd1' + idx" style="height: 2.5rem;">
            <div class="d-flex flex-grow-1">
              <b-checkbox disabled v-model="lpu.Checked"> {{ `${lpu.Descricao}-${lpu.Regiao}-Rv.${lpu.Revisao}` }}</b-checkbox>
            </div>
          </div>
          <div class="separator" v-if="currentLpuRemoved.length">{{ 'LPUs Removidas' }}</div>
          <div class="d-flex flex-shrink-1 align-items-center w-100" v-for="(lpu, idx) in currentLpuRemoved" :key="'lpuRem2' + idx" style="height: 2.5rem;">
            <div class="d-flex flex-grow-1">
              <b-checkbox disabled v-model="lpu.Checked"> {{ `${lpu.Descricao}-${lpu.Regiao}-Rv.${lpu.Revisao}` }}</b-checkbox>
            </div>
          </div>
          <!-- <div class="separator" v-if="currentLpuRemoved.length"></div>
          <div class="d-flex flex-shrink-1 align-items-center w-100" v-for="(lpu, idx) in currentLpuRemoved" :key="'lpuRem1' + idx" style="height: 2.5rem;">
            ---
          </div> -->
          <div class="separator" v-if="currentItemsAdded.length">{{ $lang.PCI.Mounting.Log.AddedItems }}</div>
          <div class="d-flex flex-shrink-1 align-items-center w-100" v-for="(item, idx) in currentItemsAdded" :key="'itemsAdd1' + idx" style="height: 2.5rem;">
            <div class="d-flex flex-grow-1">
              <b-checkbox disabled v-model="item.Checked"> {{ `(${item.Codigo}) ${item.Descricao}` }}</b-checkbox>
            </div>
            <div class="d-flex flex-shrink-1">
              <b-checkbox class="d-flex align-items-center" v-if="item.PossuiCor" switch v-model="item.Colorido" disabled>
                <i class="fas fa-palette text-primary"></i>
              </b-checkbox>
            </div>
          </div>
          <div class="separator" v-if="currentItemsRemoved.length">{{ $lang.PCI.Mounting.Log.RemovedItems }}</div>
          <div class="d-flex flex-shrink-1 align-items-center w-100" v-for="(item, idx) in currentItemsRemoved" :key="'itemRem2' + idx" style="height: 2.5rem;">
            <div class="d-flex flex-grow-1">
              <b-checkbox disabled v-model="item.Checked"> {{ `(${item.Codigo}) ${item.Descricao}` }}</b-checkbox>
            </div>
            <div class="d-flex flex-shrink-1">
              <b-checkbox class="d-flex align-items-center" v-if="item.PossuiCor" switch v-model="item.Colorido" disabled>
                <i class="fas fa-palette text-primary"></i>
              </b-checkbox>
            </div>
          </div>
          <!-- <div class="separator" v-if="currentItemsRemoved.length"></div>
          <div class="d-flex flex-shrink-1 align-items-center w-100" v-for="(item, idx) in currentItemsRemoved" :key="'itemsRem1' + idx" style="height: 2.5rem;">
            ---
          </div> -->
        </div>
        <div class="d-flex flex-column w-100 col-6">
          <div class="separator" v-if="currentLinkedContract.contractID !== beforeLinkedContract.contractID">{{ 'Contratos Vinculados (Atual)' }}</div>
          <div class="d-flex flex-shrink-1 align-items-center w-100" v-if="currentLinkedContract.contractID !== beforeLinkedContract.contractID" style="height: 2.5rem;">
            <div class="d-flex flex-shrink-1">
              <v-select v-if="currentLinkedContract.contractID" :options="listContract" v-model="currentLinkedContract" label="contract" :getOptionKey="param => param.contractID" disabled class="w-100" :clearable="false"></v-select>
            </div>
          </div>
          <div class="separator" v-if="currentItemsDiff.length || logItemsDiff.length">{{ $lang.PCI.Mounting.Log.CurrentModifiedItems }}</div>
          <div class="d-flex flex-shrink-1 align-items-center w-100" v-for="(item, idx) in currentItemsDiff" :key="idx" style="height: 2.5rem;">
            <div class="d-flex flex-grow-1">
              <b-checkbox disabled v-model="item.Checked"> {{ `(${item.Codigo}) ${item.Descricao}` }}</b-checkbox>
            </div>
            <div class="d-flex flex-shrink-1">
              <b-checkbox class="d-flex align-items-center" v-if="item.PossuiCor" switch v-model="item.Colorido" disabled>
                <i class="fas fa-palette text-primary"></i>
              </b-checkbox>
              <div class="d-flex align-items-center" v-if="item.Automatizacoes.length">
                <strong v-if="item.AutomatizacoesMont.length" class="pl-1">Autom.</strong>
                <v-select v-if="item.AutomatizacoesMont.length" :options="item.Automatizacoes" v-model="item.AutomatizacoesMont" label="nome" disabled :clearable="false"></v-select>
              </div>
              <div class="d-flex align-items-center" v-if="item.Validacoes.length" >
                <strong v-if="item.ValidacoesMont.length" class="pl-1">Valid.</strong>
                <v-select v-if="item.ValidacoesMont.length" :options="item.Validacoes" v-model="item.ValidacoesMont" label="nome" multiple disabled :clearable="false"></v-select>
              </div>
            </div>
          </div>
          <!-- <div class="separator" v-if="currentLpuAdded.length"></div>
          <div class="d-flex flex-shrink-1 align-items-center w-100" v-for="(item, idx) in currentLpuAdded" :key="'lpuAdd2' + idx" style="height: 2.5rem;">
            ---
          </div> -->
          <!-- <div class="separator" v-if="currentItemsAdded.length"></div>
          <div class="d-flex flex-shrink-1 align-items-center w-100" v-for="(item, idx) in currentItemsAdded" :key="'itemAdd2' + idx" style="height: 2.5rem;">
            ---
          </div> -->
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import PCIRepository from '@/shared/http/repositories/pci/pci'
import { AgGridVue } from 'ag-grid-vue'
import { loading } from '@/shared/utils/UIHelper'
import gridMixin from '../mixins/gridMixin'
import CompanyMixin from '@/store/module/company/mixin'
export default {
  name: 'Log',
  components: {
    AgGridVue
  },
  mixins: [gridMixin, CompanyMixin],
  props: {
    listLpu: {
      type: Array,
      required: true
    },
    listContract: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      showLogModal: false,
      contract: null,
      objList: [],
      lastRow: {},
      currentLinkedContract: {},
      beforeLinkedContract: {},
      currentLpuAdded: [],
      currentLpuRemoved: [],
      currentItems: [],
      currentItemsAdded: [],
      currentItemsRemoved: [],
      currentItemsDiff: [],
      logItemsDiff: [],
      columnDefs: [
        {
          headerName: this.$lang.PCI.Mounting.Log.Datatable.Date,
          field: 'dataAcaoFormatada'
        },
        {
          headerName: this.$lang.PCI.Mounting.Log.Datatable.User,
          field: 'nomeContaAcao'
        }
      ]
    }
  },
  methods: {
    show (contract) {
      this.clear()
      this.currentItems = []
      this.contract = contract

      loading.push()
      const promises = [Promise.resolve]
      promises.push(PCIRepository.GetPCIItemsByPciID(this.company.id, this.contract.pciID)
        .then(response => {
          if (response.data.code > 0) {
            this.currentItems = response.data.data
          }
        })
      )
      promises.push(PCIRepository.GetLogs(contract.pciID)
        .then(response => {
          if (response.data.code > 0) {
            const obj = response.data.data.map(d => {
              const json = JSON.parse(d.logGenericoData.json)
              return {
                ContratoVinculadoID: json.ContratoVinculadoID,
                LpusPci: json.LpusPci.map(l => {
                  return {
                    LpuID: l.LpuID
                  }
                }),
                PCIItems: json.PCIItems.map(i => {
                  return {
                    PCIModeloItemID: i.PCIModeloItemID,
                    AutomatizacoesMont: i.AutomatizacoesMont.map(a => {
                      return {
                        PCIModeloItemStatusID: a.PCIModeloItemStatusID
                      }
                    }),
                    ValidacoesMont: i.ValidacoesMont.map(v => {
                      return {
                        PCIModeloItemValidID: v.PCIModeloItemValidID
                      }
                    })
                  }
                })
              }
            })

            this.objList = response.data.data.filter((d, idx) => {
              let result = false
              if (idx < response.data.data.length - 1) {
                result = JSON.stringify(obj[idx]) !== JSON.stringify(obj[idx + 1])
              } else {
                this.lastRow = d
              }
              return result
            })

            this.showLogModal = true
          }
        })
      )

      Promise.all(promises)
        .then(() => {
          loading.close()
          this.$nextTick(() => {
            this.gridOptions.api.sizeColumnsToFit()
          })
        })
    },
    clear () {
      this.currentLinkedContract = {}
      this.beforeLinkedContract = {}
      this.currentLpuAdded = []
      this.currentLpuRemoved = []
      this.currentItemsAdded = []
      this.currentItemsRemoved = []
      this.currentItemsDiff = []
      this.logItemsDiff = []
    },
    onSelectLine (params) {
      if (!params.node.selected) return

      let nextRow = this.gridOptions.api.rowModel.getRow(params.rowIndex + 1) || {data: this.lastRow}
      // if (!nextRow) {
      //   this.clear()
      //   return
      // }

      const curLinkContrID = JSON.parse(params.data.logGenericoData.json).ContratoVinculadoID
      const befLinkContrID = JSON.parse(nextRow.data.logGenericoData.json).ContratoVinculadoID
      this.currentLinkedContract = this.listContract.filter(c => c.contractID === curLinkContrID)[0] || {contract: '   '}
      this.beforeLinkedContract = this.listContract.filter(c => c.contractID === befLinkContrID)[0] || {contract: '   '}

      const lpus = JSON.parse(params.data.logGenericoData.json).LpusPci
      const lpusBefore = JSON.parse(nextRow.data.logGenericoData.json).LpusPci

      this.currentLpuAdded = lpus.filter(curLpu =>
        !lpusBefore.some(lpu =>
          lpu.LpuID === curLpu.LpuID
        )
      ).map(curLpu => {
        const lpu = this.listLpu.filter(lpu => lpu.id === curLpu.LpuID)[0]
        return {
          Descricao: lpu ? lpu.descricao : '',
          Regiao: lpu ? lpu.regiao : '',
          Revisao: lpu ? lpu.revisao : '',
          Checked: true
        }
      })

      this.currentLpuRemoved = lpusBefore.filter(nextLpu =>
        !lpus.some(lpu =>
          lpu.LpuID === nextLpu.LpuID
        )
      ).map(nextLpu => {
        const lpu = this.listLpu.filter(lpu => lpu.id === nextLpu.LpuID)[0]
        return {
          Descricao: lpu ? lpu.descricao : '',
          Regiao: lpu ? lpu.regiao : '',
          Revisao: lpu ? lpu.revisao : '',
          Checked: false
        }
      })

      const logItems = JSON.parse(params.data.logGenericoData.json).PCIItems
      const logItemsBefore = JSON.parse(nextRow.data.logGenericoData.json).PCIItems

      const arrayEquals = (a, b, field) => {
        return Array.isArray(a) &&
          Array.isArray(b) &&
          a.length === b.length &&
          a[field] === b[field]
      }

      this.currentItemsAdded = logItems.filter(curItem =>
        !logItemsBefore.some(logItem =>
          logItem.PCIModeloItemID === curItem.PCIModeloItemID
        )
      ).map(curItem => {
        const item = this.currentItems.filter(it => it.id === curItem.PCIModeloItemID)[0]
        return {
          Codigo: item.codigo,
          Descricao: item.descricao,
          Automatizacoes: item.automatizacoes,
          Validacoes: item.validacoes,
          Colorido: curItem.Colorido,
          AutomatizacoesMont: item.automatizacoes.filter(aut => curItem.AutomatizacoesMont.some(autMont => autMont.PCIModeloItemStatusID === aut.id)),
          ValidacoesMont: item.validacoes.filter(val => curItem.ValidacoesMont.some(valMont => valMont.PCIModeloItemValidID === val.id)),
          Checked: true
        }
      })

      this.currentItemsDiff = logItems.filter(curItem =>
        logItemsBefore.some(logItem =>
          logItem.PCIModeloItemID === curItem.PCIModeloItemID && (
            !arrayEquals(logItem.AutomatizacoesMont, curItem.AutomatizacoesMont, 'PCIModeloItemStatusID') ||
            !arrayEquals(logItem.ValidacoesMont, curItem.ValidacoesMont, 'PCIModeloItemValidID') ||
            logItem.Colorido !== curItem.Colorido
          )
        )
      ).map(curItem => {
        const item = this.currentItems.filter(it => it.id === curItem.PCIModeloItemID)[0]
        return {
          Codigo: item.codigo,
          Descricao: item.descricao,
          Automatizacoes: item.automatizacoes,
          Validacoes: item.validacoes,
          Colorido: curItem.Colorido,
          AutomatizacoesMont: item.automatizacoes.filter(aut => curItem.AutomatizacoesMont.some(autMont => autMont.PCIModeloItemStatusID === aut.id)),
          ValidacoesMont: item.validacoes.filter(val => curItem.ValidacoesMont.some(valMont => valMont.PCIModeloItemValidID === val.id)),
          Checked: true
        }
      })

      this.currentItemsRemoved = logItemsBefore.filter(logItem =>
        !logItems.some(curItem =>
          curItem.PCIModeloItemID === logItem.PCIModeloItemID
        )
      ).map(logItem => {
        const item = this.currentItems.filter(it => it.id === logItem.PCIModeloItemID)[0]
        return {
          Codigo: item.codigo,
          Descricao: item.descricao,
          Automatizacoes: item.automatizacoes,
          Validacoes: item.validacoes,
          Colorido: logItem.Colorido,
          AutomatizacoesMont: item.automatizacoes.filter(aut => logItem.AutomatizacoesMont.some(autMont => autMont.PCIModeloItemStatusID === aut.id)),
          ValidacoesMont: item.validacoes.filter(val => logItem.ValidacoesMont.some(valMont => valMont.PCIModeloItemValidID === val.id)),
          Checked: true
        }
      })

      this.logItemsDiff = logItemsBefore.filter(logItem =>
        logItems.some(curItem =>
          curItem.PCIModeloItemID === logItem.PCIModeloItemID && (
            !arrayEquals(curItem.AutomatizacoesMont, logItem.AutomatizacoesMont, 'PCIModeloItemStatusID') ||
            !arrayEquals(curItem.ValidacoesMont, logItem.ValidacoesMont, 'PCIModeloItemValidID') ||
            curItem.Colorido !== logItem.Colorido
          )
        )
      ).map(logItem => {
        const item = this.currentItems.filter(it => it.id === logItem.PCIModeloItemID)[0]
        return {
          Codigo: item.codigo,
          Descricao: item.descricao,
          Automatizacoes: item.automatizacoes,
          Validacoes: item.validacoes,
          Colorido: logItem.Colorido,
          AutomatizacoesMont: item.automatizacoes.filter(aut => logItem.AutomatizacoesMont.some(autMont => autMont.PCIModeloItemStatusID === aut.id)),
          ValidacoesMont: item.validacoes.filter(val => logItem.ValidacoesMont.some(valMont => valMont.PCIModeloItemValidID === val.id)),
          Checked: true
        }
      })
    }
  }
}
</script>

<style scoped>
.separator {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  text-align: center;
  height: 1rem;
  color: gray;
}
.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px dotted lightgray;
}
.separator:not(:empty)::before {
  margin-right: .25em;
}
.separator:not(:empty)::after {
  margin-left: .25em;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/mounting/log.vue